import { useEffect } from "react";
import Contact from "@/components/sections/Contact";

export default function ContactPage() {
  useEffect(() => { document.title = "Contact — Warranty_Vault pro"; }, []);
  return (
    <main className="pt-16" data-testid="contact-page">
      <Contact />
    </main>
  );
}
